import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@mui/material/Tooltip';
import { StyledLink } from './styles';

const Link = ({ children, ...rest }) => {
	return (
		<Tooltip title={rest.tooltipTitle} disableHoverListener={!rest.tooltipTitle}>
			<StyledLink variant={rest.variant || 'body1'} rel={rest.target === '_blank' ? 'noopener' : ''} {...rest}>
				{children}
			</StyledLink>
		</Tooltip>
	);
};

Link.propTypes = {
	children: PropTypes.node.isRequired
};

export default Link;
